import { render, staticRenderFns } from "./AddWhiteContacts.vue?vue&type=template&id=2b804a70&scoped=true&"
import script from "./AddWhiteContacts.vue?vue&type=script&lang=js&"
export * from "./AddWhiteContacts.vue?vue&type=script&lang=js&"
import style0 from "./AddWhiteContacts.vue?vue&type=style&index=0&id=2b804a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b804a70",
  null
  
)

export default component.exports